<div class="banner-psicologa">
  <div class="row g-0 align-items-center">
    <div class="col-md-7 p-4">
      <div class="banner-content-psicologa text-center">
        <div class="title-subtitle-wrapper">
          <h1 class="banner-title-psicologa">
            <em>Bienvenid&#64; a <span class="brand-highlight-psicologa">Psicologa.co</span></em>
          </h1>
          <p class="banner-subtitle-psicologa">
            Nos alegra <strong>acompañarte</strong> en tu proceso de <em>bienestar</em> emocional
          </p>
        </div>

        <div class="mt-4">
          <button
            routerLink="/buscador-wizard"
            class="btn btn-primary-banner-psicologa"
          >
            Encuentra a tu especialista
          </button>
        </div>

        <div *ngIf="error !== ''" class="text-danger mt-2 text-center" style="font-size: 11px">
          {{ error }}
        </div>

        <!-- Separador con forma de electrocardiograma -->
        <div class="separador-banner-psicologa">
          <svg width="100%" height="20" viewBox="0 0 200 20" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0" y1="10" x2="70" y2="10" stroke="#cbd5e0" stroke-width="1"/>
            <polyline points="70,10 75,10 78,3 81,17 84,10 87,10" fill="none" stroke="#cbd5e0" stroke-width="1"/>
            <line x1="87" y1="10" x2="200" y2="10" stroke="#cbd5e0" stroke-width="1"/>
          </svg>
        </div>

        <form>
          <div class="row" style="display: none">
            <div class="form-group col-md-6 p-2">
              <select
                id="sedes"
                class="form-control"
                [(ngModel)]="searchSede"
                name="searchSede"
              >
                <option value="" selected>Elige una sede</option>
                @for (sede of sedes; track sede) {
                <option [value]="sede['$id']">{{ sede["sede"] }}</option>
                }
              </select>
            </div>
            <div class="form-group col-md-6 p-2">
              <select
                id="servicio"
                class="form-control"
                [(ngModel)]="searchServicio"
                name="searchServicio"
              >
                <option value="" selected>Elige un servicio</option>
                @for (servicio of servicios; track servicio) {
                <option [value]="servicio['$id']">
                  {{ servicio["servicio"] }}
                </option>
                }
              </select>
            </div>
            <div class="form-group col-md-6 p-2">
              <select
                id="especialidad"
                class="form-control"
                [(ngModel)]="searchEspecialidad"
                name="searchEspecialidad"
              >
                <option value="" selected>Elige una especialidad</option>
                @for (especialidad of especialidades; track especialidad) {
                <option [value]="especialidad['$id']">
                  {{ especialidad["especialidad"] }}
                </option>
                }
              </select>
            </div>
            <div class="form-group col-md-6 p-2">
              <select
                id="tipo"
                class="form-control"
                [(ngModel)]="searchTipoEspecialista"
                name="searchTipoEspecialista"
              >
                <option value="" selected>Elige un tipo de atención</option>
                @for (tipo of tiposEspecialistas; track tipo) {
                <option [value]="tipo['$id']">
                  {{ tipo["especialidad"] }}
                </option>
                }
              </select>
            </div>
          </div>
          <div class="text-center">
            <button
              class="btn btn-secondary-banner-psicologa"
              (click)="bucarEspecialista()"
              type="button"
            >
              Agendar tu cita
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-5">
      <img
        class="banner-image-psicologa img-fluid"
        src="assets/images/main-right.png"
        alt="Psicologa banner"
      />
    </div>
  </div>
</div>